<!-- header -->
<div class="py-8 md:flex md:items-center md:justify-between">
	<div class="min-w-0 flex-1">
		<h2 class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">Mein Profil</h2>
	</div>
	<div class="mt-4 flex md:ml-4 md:mt-0"></div>
</div>
<!-- tabs -->
<div class="border-b border-gray-200 pb-5 sm:pb-0">
  <div class="mt-3 sm:mt-4">
    <div class="sm:hidden">
      <label for="current-tab" class="sr-only">Select a tab</label>
      <select id="current-tab" name="current-tab" class="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm">
        <option>Meine Daten</option>
      </select>
    </div>
    <div class="hidden sm:block">
      <nav class="-mb-px flex space-x-8">
        <a (click)="tab = 1" class="tab" [class.active]="tab == 1">Meine Daten</a>
      </nav>
    </div>
  </div>
  </div>
<!-- meine daten -->
<div *ngIf="tab == 1">
  <form [formGroup]="form_data">
    <div class="space-y-12">
      <div class="pb-12">
        <div class="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
        	<div class="sm:col-span-6 sm:grid sm:grid-cols-2 sm:gap-x-6">
				<div>
					<label for="first-name">Vorname</label>
					<div class="mt-2">
						<input formControlName="first_name" type="text">
					</div>
				</div>
				<div>
					<label for="first-name">Nachname</label>
					<div class="mt-2">
						<input formControlName="last_name" type="text">
					</div>
				</div>
			</div>
			<div class="sm:col-span-6">
				<label for="first-name">Profilbild</label>
				<ng-container *ngIf="user.acf?.profilbild">
					<img [src]="user.acf.profilbild" width="200" class="mt-2" />
				</ng-container>
				<div class="mt-2">
					<input (change)="onProfileImageChange($event)" id="file_input" type="file">
				</div>
			</div>
			<div class="sm:col-span-6">
				<label for="first-name">E-Mail-Adresse</label>
				<div class="mt-2">
					<input formControlName="email" type="text">
				</div>
			</div>
        </div>
      </div>
    </div>
    <div *ngIf="!loading_data" class="mt-6 flex items-center justify-end gap-x-6">
      <button type="submit" class="primary" [disabled]="form_data.invalid" (click)="updateUser(user.id)">Speichern</button>
    </div>
    <div *ngIf="loading_data" class="text-right mt-6">
      <div role="status">
        <svg aria-hidden="true" class="inline w-9 h-9 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#333"/>
        </svg>
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div *ngIf="saved" class="rounded bg-signal-green p-4 my-4">
      <p class="text-white">Daten wurden erfolgreich gespeichert.</p>
    </div>
  </form>
</div>